import { useEffect, useState } from "react";
import Common from "../../helper/common";
import { Button } from "../../components/ui/button";
import { Icon } from "@iconify/react";
import { AppSearchSelect } from "../../components/appComponents";
import AdvanceTable from "../../components/advanceTable";
import AddSlider from "./slider/addslider";
import {
  SearchTypeEnum,
  SliderDisplayTypeEnum,
  SliderTypeEnum,
  ViewDateFormat,
  ViewDateTimeFormat,
} from "../../constants/appConstant";

import { respEnum } from "../../constants/appConstant";
import Utility from "../../helper/utilityHelper";

const Sliders = () => {
  // let [fromDate, setfromDate] = useState(null);
  // let [tillDate, settillDate] = useState(null);
  const [data, setData] = useState({});
  let [search, setSearch] = useState(null);
  const [clubId, setClubId] = useState(null);
  const [accountList, setAccountList] = useState([]);
  const [open, setOpen] = useState(false);
  const [refId, setRefId] = useState(null);

  // useEffect(() => {
  //   getData(1);
  //   getClubAccount();
  // }, []);

  useEffect(() => {
    if (!open && refId) {
      setRefId();
    }
  }, [open, refId]);

  useEffect(() => {
    getData();
    getClubAccount();
  }, [
    clubId,

    // , fromDate, tillDate
  ]);

  const resetFilters = () => {
    // setfromDate(null);
    // settillDate(null);
    setSearch(null);
    console.log("reset filter");

    setClubId(null);
  };

  const getData = async (
    pageNumber,
    searchTerm = search,
    recordsToDisplay = null
  ) => {
    // if (fromDate == "") fromDate = null;

    // if (tillDate == "") tillDate = null;

    const response = await Common.ApiService.getInstance().request(
      "GetSliderList",
      {
        pageNumber: pageNumber,
        q: searchTerm,
        isactive: true,
        recordsToDisplay,
        clubid: clubId,
        // fromDate,
        // tillDate,
      },

      "Post"
    );

    if (response?.data) {
      debugger;
      let obj = {
        ...response.data[0],
        data: response.data[0].data.map((item) => ({
          ...item,
          createdon: Common.Utility.ConvertTime(item.createdon),
          updatedon: Common.Utility.ConvertTime(item.updatedon),
          clubName: item.clubName ?? "-",
          type: Common.Utility.getKeyByValue(SliderTypeEnum, item.type) ?? "-",
          // fromdate: Common.Utility.ConvertTime(item.fromdate) ?? "-",
          // tilldate: Common.Utility.ConvertTime(item.tilldate) ?? "-",
          // desc: item.desc === (null || " ") ? "-" : item.desc,
          desc: !item.desc || item.desc.trim() === "" ? "-" : item.desc.trim(),

          url: item.url ?? "-",
          sliderroute: item.sliderroute ?? "-",
          fromdate:
            Common.moment(item.fromdate).format(ViewDateTimeFormat) !=
            "Invalid date"
              ? Common.moment(item.fromdate).format(ViewDateTimeFormat)
              : "-",
          tilldate:
            Common.moment(item.tilldate).format(ViewDateTimeFormat) !=
            "Invalid date"
              ? Common.moment(item.tilldate).format(ViewDateTimeFormat)
              : "-",

          refId: item.refId ?? "-",
          title:item.title??"-",
          banner: item.banner == null ? "-" : item.banner,
          displaytype: Common.Utility.getKeyByValue(SliderDisplayTypeEnum,item.displaytype) ?? "-",
        })),
      };

      // console.log(
      //   obj.data?.[0].banner == null ? "-" : obj.data?.[0].banner,
      //   "asda"
      // );

      setData(obj);
    }
  };

  const getClubAccount = async () => {
    return new Promise(async (res) => {
      const response = await Common.ApiService.getInstance().request(
        "GetClubsDDL"
      );
      const data = [{ id: null, name: "All" }, ...(response?.data ?? [])];

      setAccountList(data);
    });
  };

  const _handleOnChange = async (obj) => {
    debugger;

    let resp = await Common.ApiService.getInstance().request(
      `ActiveDeactiveSlider?id=${obj.id}&isactive=${!obj.isactive}`,
      {},
      "POST"
    );
    if (resp.status === respEnum.Success) {
      Common.SweetAlert.alert(resp.message, "success");
      setTimeout(() => {
        //setData(
        //    data.data.map((item) =>
        //        item.id == obj.id ? { ...item, isActive: !item.isActive } : item
        //    )
        //);
        getData(1);
      }, 300);
    }
  };

  const columns = [
    { title: "Id", type: "number", isVisible: false, key: "id" },
    {
      title: "Banner",
      type: "image",
      isVisible: true,
      key: "banner",
      render: (_, record) => (
        <img
          src={Utility.getImagePath(record?.banner?.path)}
          alt={record?.banner?.title || "Banner Image"}
          className="w-150 h-150 object-cover rounded-lg"
        />
      ),
    },
    { title: "Club", type: "text", isVisible: true, key: "clubName" },
    { title: "Title", type: "text", isVisible: true, key: "title" },
    { title: "Url", type: "text", isVisible: true, key: "url" },
    {
      title: "Slider Route",
      type: "text",
      isVisible: false,
      key: "sliderroute",
    },

    { title: "Type", type: "text", isVisible: true, key: "type" },
    { title: "Display Type", type: "text", isVisible: true, key: "displaytype" },
    { title: "Ref ID", type: "text", isVisible: true, key: "refId" },
    { title: "Description", type: "text", isVisible: true, key: "desc" },
    { title: "From Date", type: "date", isVisible: true, key: "fromdate" },
    { title: "Till Date", type: "date", isVisible: true, key: "tilldate" },
    {
      title: "Is Active",
      type: "toggle",
      isVisible: true,
      key: "isactive",
      onChanged: (item) => _handleOnChange(item),
    },
  ];

  const actions = [
    {
      type: "edit",
      onClick: (val) => _onEdit(val.id),
    },
    {
      type: "delete",
      onClick: (val) => _handleDelete(val.id),
    },
  ];

  const _onEdit = async (id) => {
    setOpen(true);
    setRefId(id);
  };

  const _handleDelete = async (id) => {
    const isConfirmed = await Common.SweetAlert.confirmation(
      "Are you sure want to delete this Slider??",
      "Delete Slider"
    );

    if (isConfirmed) {
      let resp = await Common.ApiService.getInstance().request(
        `DeleteSlider?id=${id}`,
        {},
        "Delete"
      );

      Common.SweetAlert.alert(resp.message, "success");

      setTimeout(() => {
        getData(1);
      }, 500);
    }
  };

  const _addUpdateTrigger = () => {
    <Button size="icon" variant="outline" color="secondary" className="h-7 w-7">
      <Icon icon="heroicons:pencil" className="h-4 w-4" />
    </Button>;
  };

  return (
    <>
      <div className="md:grid md:grid-cols-6 gap-3 h-150 w-150 ">
        {/* <AppInput
          type={"date"}
          value={fromDate}
          onChange={(e) => {
            const selectedstartDate = e;
            if (tillDate && selectedstartDate > tillDate) {
              Common.showToast(
                "From Date must be lesser than till Date",
                "Error",
                "info"
              );
              setfromDate(null);
            } else {
              setfromDate(selectedstartDate);
            }
          }}
          label="From"
          className="mb-3 col-span-1"
        /> */}

        {/* <AppInput
          type={"date"}
          value={tillDate}
          onChange={(e) => {
            const selectedEndDate = e;
            if (selectedEndDate < fromDate) {
              Common.showToast("Till Date must be greater", "Error", "info");
              settillDate("");
            } else {
              settillDate(selectedEndDate);
            }
          }}
          label="Till"
          className="mb-3 col-span-1"
        /> */}

        <AppSearchSelect
          value={clubId}
          onChange={setClubId}
          placeholder={"All"}
          label={"Club Name"}
          data={accountList}
          className={"mb-3 col-span-1"}
        />

        <Button className="lg:mt-6 h-8 mb-5" onClick={resetFilters}>
          Reset Filter
        </Button>
      </div>

      {data?.data && (
        <AdvanceTable
          title={"Sliders"}
          columns={columns.filter((item) => item.isVisible)}
          data={data}
          getData={getData}
          addButton={() => (
            <AddSlider
              id={refId}
              onClose={() => getData()}
              open={open}
              setOpen={setOpen}
            />
          )}
          showPagination
          showAddButton
          actionButtons={actions}
          updateTrigger={_addUpdateTrigger}
          searchInputClassName="custom-search-mobile"
          search={SearchTypeEnum.Server_Search}
        />
      )}
    </>
  );
};

export default Sliders;
